// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var DOM$SmartcutsMacros = require("../DOM.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var TextContents$SmartcutsMacros = require("../TextContents.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../DOM__HtmlElement.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function t_encode(encoder_domElementRepresentation, v) {
  return Js_dict.fromArray([
              [
                "contentEditableHost",
                Curry._1(encoder_domElementRepresentation, v.contentEditableHost)
              ],
              [
                "domElementRepresentation",
                Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
              ],
              [
                "textNodeIndex",
                Decco.intToJson(v.textNodeIndex)
              ],
              [
                "offset",
                Decco.intToJson(v.offset)
              ],
              [
                "textContents",
                TextContents$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v.textContents)
              ]
            ]);
}

function t_decode(decoder_domElementRepresentation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var contentEditableHost = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableHost"), null));
  if (contentEditableHost.TAG === /* Ok */0) {
    var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
    if (domElementRepresentation.TAG === /* Ok */0) {
      var textNodeIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNodeIndex"), null));
      if (textNodeIndex.TAG === /* Ok */0) {
        var offset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
        if (offset.TAG === /* Ok */0) {
          var textContents = TextContents$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "textContents"), null));
          if (textContents.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      contentEditableHost: contentEditableHost._0,
                      domElementRepresentation: domElementRepresentation._0,
                      textNodeIndex: textNodeIndex._0,
                      offset: offset._0,
                      textContents: textContents._0
                    }
                  };
          }
          var e = textContents._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".textContents" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = offset._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".offset" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = textNodeIndex._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".textNodeIndex" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = domElementRepresentation._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".domElementRepresentation" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = contentEditableHost._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".contentEditableHost" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function stringify(stringifyDomElementRepresentation, param) {
  return "{contentEditableHost: " + (Curry._1(stringifyDomElementRepresentation, param.contentEditableHost) + (", domElementRepresentation: " + (Curry._1(stringifyDomElementRepresentation, param.domElementRepresentation) + (", textNodeIndex: " + (String(param.textNodeIndex) + (", offset: " + (String(param.offset) + ", textContents}")))))));
}

var Generic = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}

function t_decode$1(v) {
  return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}

function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
  if (!selectionSnapshot) {
    return ;
  }
  var match = selectionSnapshot._0;
  if (!match.collapsed) {
    return ;
  }
  var offset = match.startOffset;
  var rootNode = match.rootNode;
  var contentEditableHost = DOM$SmartcutsMacros.ContentEditable.findHost(DOM__HtmlElement$SmartcutsMacros.ofNodeOrItsAncestor(rootNode));
  var match$1 = Webapi__Dom__Node.nodeType(rootNode);
  var maybeElementAndTextNodeIndex;
  if (match$1 >= 3) {
    maybeElementAndTextNodeIndex = undefined;
  } else {
    switch (match$1) {
      case /* Element */0 :
          if (offset === 0) {
            var arg = Webapi__Dom__Element.ofNode(rootNode);
            var rootElement = (function (param) {
                  return OptionUtils$SmartcutsMacros.getExn(param, arg);
                })("Expected node to be an element");
            var textSegments = TextContents$SmartcutsMacros.TextSegment.textSegmentsFromElement(rootElement);
            if (textSegments) {
              var element = textSegments.hd;
              if (element.TAG === /* NonEmptySegment */0) {
                var match$2 = element._0;
                var textNodeIndex = match$2.textNodeIndex;
                var parentElement = match$2.parentElement;
                if (textSegments.tl) {
                  var domElementRepresentation = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, parentElement);
                  maybeElementAndTextNodeIndex = [
                    domElementRepresentation,
                    textNodeIndex
                  ];
                } else {
                  var domElementRepresentation$1 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, parentElement);
                  maybeElementAndTextNodeIndex = [
                    domElementRepresentation$1,
                    textNodeIndex
                  ];
                }
              } else {
                var element$1 = element._0;
                if (textSegments.tl) {
                  var domElementRepresentation$2 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, element$1);
                  maybeElementAndTextNodeIndex = [
                    domElementRepresentation$2,
                    -1
                  ];
                } else {
                  var domElementRepresentation$3 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, element$1);
                  maybeElementAndTextNodeIndex = [
                    domElementRepresentation$3,
                    -1
                  ];
                }
              }
            } else {
              var domElementRepresentation$4 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, rootElement);
              maybeElementAndTextNodeIndex = [
                domElementRepresentation$4,
                -1
              ];
            }
          } else {
            maybeElementAndTextNodeIndex = undefined;
          }
          break;
      case /* Attribute */1 :
          maybeElementAndTextNodeIndex = undefined;
          break;
      case /* Text */2 :
          var arg$1 = rootNode.parentElement;
          var arg$2 = (arg$1 == null) ? undefined : Caml_option.some(arg$1);
          var parentElement$1 = (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
              })("Expected to get parentElement of Text node");
          var arg$3 = Util$SmartcutsMacros.shortcutWithIndex2(Array.prototype.slice.call(parentElement$1.childNodes), (function (node, index) {
                  if (node === rootNode) {
                    return index;
                  }
                  
                }));
          var textNodeIndex$1 = (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
              })("Expected to find index Text node in parentElement.childNodes");
          var domElementRepresentation$5 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, parentElement$1);
          maybeElementAndTextNodeIndex = [
            domElementRepresentation$5,
            textNodeIndex$1
          ];
          break;
      
    }
  }
  return OptionUtils$SmartcutsMacros.map(maybeElementAndTextNodeIndex, (function (param) {
                var domElementIdentifierPairedWithSelector_for_contentEditableHost = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, contentEditableHost);
                var textContents = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.fromElement(domElementIdentifierGenerator, contentEditableHost);
                return {
                        contentEditableHost: domElementIdentifierPairedWithSelector_for_contentEditableHost,
                        domElementRepresentation: param[0],
                        textNodeIndex: param[1],
                        offset: offset,
                        textContents: textContents
                      };
              }));
}

function isEqual(cursorA, cursorB) {
  if (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.isEqual(cursorA.contentEditableHost, cursorB.contentEditableHost) && DomElementIdentifierPaired__WithSelector$SmartcutsMacros.isEqual(cursorA.domElementRepresentation, cursorB.domElementRepresentation) && cursorA.textNodeIndex === cursorB.textNodeIndex && cursorA.offset === cursorB.offset) {
    return Caml_obj.caml_equal(cursorA.textContents, cursorB.textContents);
  } else {
    return false;
  }
}

function isCursorAtEndOfContentEditable(param) {
  var textContents = param.textContents;
  var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
  var func$1 = Curry._1(func, param.domElementRepresentation.domElementIdentifier);
  var maybeSearchResult = Curry._2(func$1, param.textNodeIndex, textContents);
  if (maybeSearchResult === undefined) {
    return false;
  }
  var text = TextContents$SmartcutsMacros.textGet(maybeSearchResult.textContent);
  if (maybeSearchResult.index === (List.length(textContents) - 1 | 0)) {
    return param.offset === text.length;
  } else {
    return false;
  }
}

function isCursorAtStartOfContentEditable(param) {
  var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
  var func$1 = Curry._1(func, param.domElementRepresentation.domElementIdentifier);
  var maybeSearchResult = Curry._2(func$1, param.textNodeIndex, param.textContents);
  if (maybeSearchResult !== undefined && maybeSearchResult.index === 0) {
    return param.offset === 0;
  } else {
    return false;
  }
}

function updateSelector(f, param) {
  var domElementRepresentation = param.domElementRepresentation;
  var contentEditableHost = param.contentEditableHost;
  return {
          contentEditableHost: {
            domElementIdentifier: contentEditableHost.domElementIdentifier,
            selector: Curry._1(f, contentEditableHost.selector)
          },
          domElementRepresentation: {
            domElementIdentifier: domElementRepresentation.domElementIdentifier,
            selector: Curry._1(f, domElementRepresentation.selector)
          },
          textNodeIndex: param.textNodeIndex,
          offset: param.offset,
          textContents: TextContents$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, param.textContents)
        };
}

var ForRecordingAndAuthoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromSelectionSnapshot: fromSelectionSnapshot,
  isEqual: isEqual,
  isCursorAtEndOfContentEditable: isCursorAtEndOfContentEditable,
  isCursorAtStartOfContentEditable: isCursorAtStartOfContentEditable,
  updateSelector: updateSelector
};

var SelectionSnapshot;

var NonInputSelection;

exports.SelectionSnapshot = SelectionSnapshot;
exports.NonInputSelection = NonInputSelection;
exports.Generic = Generic;
exports.ForRecordingAndAuthoring = ForRecordingAndAuthoring;
/* Webapi__Dom__Node Not a pure module */
